import {
	CreateDrawerFormProps,
	FormDrawer,
	FormDrawerContent,
	FormDrawerContentProps,
	FormFetchDrawer,
	TextField,
	UpdateDrawerFormProps,
} from "@dgs/core";
import { FormikErrors } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { LocationFormValues } from "../../../shared/types/location";
import { locationService } from "../shared/api/locationService";

const useValidate = () => {
	const { t } = useTranslation();

	return (values: LocationFormValues) => {
		const errors: FormikErrors<LocationFormValues> = {};
		if (!values.name) {
			errors.name = t("Field is required");
		}
		return errors;
	};
};

const LocationFormDrawerContent: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<FormDrawerContent {...props}>
			<TextField name="name" label={t("Name")} required />
		</FormDrawerContent>
	);
};

const initialValues: LocationFormValues = {
	name: "",
};

export const LocationCreateDrawer: FC<CreateDrawerFormProps<LocationFormValues>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<FormDrawer
			{...props}
			initialValues={initialValues}
			title={t("Create location")}
			validate={validate}
			renderForm={(formProps) => <LocationFormDrawerContent {...formProps} {...props} />}
		/>
	);
};

export const LocationUpdateDrawer: FC<UpdateDrawerFormProps<LocationFormValues>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<FormFetchDrawer
			{...props}
			title={t("Edit location")}
			queryFn={() => locationService.show(props.id).then((x) => x.data.data)}
			queryKey={locationService.showKey(props.id)}
			validate={validate}
			renderSuccess={(formProps) => <LocationFormDrawerContent {...props} {...formProps} />}
		/>
	);
};
